"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalEditDriverPanelWidget = void 0;
var React = require("react");
var moment = require("moment");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../../commonFunctions");
var Detail = function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement("div", { className: "detail ".concat(className || "") }, children);
};
var DetailKey = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-key" }, children);
};
var DetailValue = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-value" }, children);
};
var RenewalEditDriverPanelWidget = /** @class */ (function (_super) {
    __extends(RenewalEditDriverPanelWidget, _super);
    function RenewalEditDriverPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToChangeAddress = function () {
            _this.props.engine.navigate("changeAddressPreset".concat(_this.getSetting("pageIdSuffix", "")), false);
        };
        var interactionField = _this.props.question.interactionField;
        if (!interactionField) {
            throw new Error("Widget ".concat(_this.props.question.type, " (").concat(_this.props.question.name, ") missing field: 'interactionField'"));
        }
        _this.driver = _this.bindFromField(interactionField);
        return _this;
    }
    RenewalEditDriverPanelWidget.prototype.render = function () {
        var _a;
        var hasDlnOnLoad = (_a = this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.hasDlnOnLoad;
        var addressIsEmpty = !this.driver.address || Object.values(this.driver.address).every(function (value) { return value === null || Array.isArray(value); });
        return (React.createElement("div", { className: "section-panel edit-driver-panel" },
            React.createElement("img", { className: "main-icon mb-2", src: "/img/account-details.png", alt: "Person silhouette icon" }),
            React.createElement("div", { className: "section border-0 p-0 edit-driver-section icon-person-before" },
                React.createElement("div", { className: "section-contents mb-5" },
                    React.createElement(Detail, { className: "edit-driver-name" },
                        React.createElement(DetailValue, null,
                            this.driver.firstName,
                            " ",
                            this.driver.lastName)),
                    React.createElement(Detail, { className: "edit-driver-dob" },
                        React.createElement(DetailKey, null, "Date of birth:"),
                        React.createElement(DetailValue, null, moment(this.driver.dateOfBirth, moment.ISO_8601).format("D MMMM YYYY"))),
                    this.driver.drivingLicenceHandy && this.driver.licence && this.driver.licence.number && hasDlnOnLoad && (React.createElement(React.Fragment, null,
                        React.createElement(Detail, { className: "edit-driver-licence" },
                            React.createElement(DetailKey, null, "Driving licence number:"),
                            React.createElement(DetailValue, null, this.driver.licence.number)),
                        React.createElement(Detail, { className: "edit-driver-motoring-convictions" },
                            React.createElement(DetailKey, null, "Motoring convictions:"),
                            React.createElement(DetailValue, null,
                                "There is no need to disclose any motoring convictions",
                                " ",
                                this.driver.firstName,
                                " ",
                                this.driver.lastName,
                                " ",
                                "might have, only if a conviction has resulted in disqualification")))),
                    !addressIsEmpty && (React.createElement(Detail, { className: "edit-driver-address" },
                        React.createElement(DetailKey, null, "Address:"),
                        React.createElement(DetailValue, null, (0, commonFunctions_1.getFullAddressString)(this.driver.address)),
                        React.createElement(DetailValue, null,
                            React.createElement("span", { id: "changeAddressButton", className: "text-blue-1 font-weight-semi-bold text-decoration-underline cursor-pointer", role: "button", tabIndex: 0, onClick: this.navigateToChangeAddress }, "Change address")))))),
            React.createElement(plugin_journey_1.QuestionList, __assign({}, this.props, { questions: this.props.question.questions }))));
    };
    return RenewalEditDriverPanelWidget;
}(plugin_journey_1.WidgetBase));
exports.RenewalEditDriverPanelWidget = RenewalEditDriverPanelWidget;
//# sourceMappingURL=RenewalEditDriverPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/RenewalEditDriverPanelWidget.js
// module id = 3197
// module chunks = 0